module.exports = __webpack_public_path__ + "static/media/uaic-building.8ff8a687.svg";